import SVGIconWrapper from "./SVGIconWrapper"

const IconAlerts = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 212 212"
        iconClass={`icon--alerts ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M106 122.37a6 6 0 0 1-6-6v-64a6 6 0 0 1 12 0v64a6 6 0 0 1-6 6z" /><circle cx="106" cy="148.23" r="8.64" /><path d="M106 212a106 106 0 1 1 106-106 106.12 106.12 0 0 1-106 106zm0-202a96 96 0 1 0 96 96 96.11 96.11 0 0 0-96-96z" />
    </SVGIconWrapper>
)

export default IconAlerts